import PropTypes from "prop-types";
import { BlocksViewer } from "@/react/components/Spaces/CourseSpace/Lockscreen/BlocksViewer/BlocksViewer";
import { useGetLockscreenBlocks } from "@/react/components/Spaces/CourseSpace/Lockscreen/hooks";
import {
  useCurrentSpaceContext,
  useSpaceResource,
} from "@circle-react/contexts";
import { Loader } from "@circle-react-uikit/Loader";

export const CourseLockScreen = () => {
  const { data: spaceFromIndex = {} } = useCurrentSpaceContext();

  // We obtain the space resource through the show action to receive a
  // JSON response that includes course sections and lessons,
  // which are not included in the index version.
  const { data: spaceFromShow } = useSpaceResource({
    spaceId: spaceFromIndex?.id,
  });

  const blocks = useGetLockscreenBlocks(spaceFromShow);

  if (!spaceFromShow) {
    return <Loader />;
  }

  return <BlocksViewer blocks={blocks} />;
};

CourseLockScreen.propTypes = {
  space: PropTypes.object.isRequired,
};
